<template>
  <div id="shareRecords">
      <span id="srTitle" v-text="sRText"></span>
      <div id="srTable">
          <ul id="srTh" class="cle">
              <li :class="[items.class,'fl']" v-for="(items,index) in title" :key="index" v-text="items.text" :title="items.text"></li>
          </ul>
          <ul v-for="(item,index) in setList" :key="index" class="cle">
              <li :class="[title[indexs].class,'fl']" v-for="(items,indexs) in item" :key="indexs" v-text="items.text" :title="items.text"></li>
          </ul>
          <div id="page"></div>
      </div>
  </div>
</template>
<script>
export default {
  name:'ShareRecords',
  props:['language'],
  data(){
      return{
          sRText:'',
          title:[
              {text:'',class:'title-2'},
              {text:'',class:'title-5'},
              {text:'',class:'title-5'},
              {text:'',class:'title-5'},
              {text:'',class:'title-5'},
              {text:'',class:'title-5'}
          ],
          setList:[[],[],[],[],[],[]]
      }
  },
  updated:function(){
      this.lang();
  },
  mounted:function(){
      for(var i=0;i<this.setList.length;i++){
        for(var a=0;a<6;a++){
            this.setList[i].push({text:''});
        };
      };
    },
  methods:{
      lang:function(){
          this.sRText=this.language['K042_ShareRecord'];
          this.title=[
              {text:this.language['K023_DeviceName'],class:'title-2'},
              {text:this.language['K043_ShareTo'],class:'title-5'},
              {text:this.language['K044_FriendAccount'],class:'title-5'},
              {text:this.language['K045_UserRole'],class:'title-5'},
              {text:this.language['K040_ValidTerm'],class:'title-5'},
              {text:this.language['K041_Describe'],class:'title-5'}
          ];
      }
  },
//   watch:{
//       language:function(){
//         this.lang();
//     },
//   }
}
</script>
<style scoped>
    #shareRecords{
        width:100%;
        height:230px;
    }
    #srTitle{
        font-size:14px;
        font-weight: bold;
        color:#229EF1;
        padding-left:10px;
        box-sizing: border-box;
    }
    #srTable{
        width:100%;
    }
    #srTable ul{
        width:100%;
        height:24px;
    }
    #srTable ul li{
        height:24px;
        font-size:12px;
        line-height:24px;
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        box-sizing: border-box;
    }
    #srTable ul li+li{
        border-left:1px solid #BFC7D2;
    }
    #srTable ul:nth-child(n+1) li{
        border-top:1px solid #BFC7D2;
    }
    #srTh{
        background-color: #7F8B9B;
    }
    #srTh li{
        color:#fff;
        font-weight: bold;
    }
    #srTable ul+ul{
        background-color: #FFFFFF;
    }
    #srTable ul+ul li{
        color:#000;
    }
    .title-1{
        width:8%;
    }
    .title-2{
        width:10%;
    }
    .title-3{
        width:12%;
    }
    .title-4{
        width:16%;
    }
    .title-5{
        width:18%;
    }
    #page{
        width:100%;
        height:24px;
    }
</style>





// WEBPACK FOOTER //
// src/components/ShareRecords.vue